import type { ReactNode } from 'react';

import { centerContainerStyle, contentStyle } from './AuthLayoutContent.css';

export const AuthLayoutContent = ({ children }: { children: ReactNode }) => {
  return (
    <div className={contentStyle}>
      <div className={centerContainerStyle}>{children}</div>
    </div>
  );
};
